import {
  address,
  birthdate,
  city,
  companyAddress,
  companyCity,
  companyCountry,
  companyPhone,
  companyProvince,
  companySdi,
  companyVat,
  companyZip,
  country,
  customerCity,
  customerName,
  email,
  name,
  pec,
  phone,
  province,
  reportEmail,
  sdi,
  selectType,
  subscriptonName,
  surname,
  vat,
  zip,
} from "../../../costants/costants";
import { numberType } from "../../../utilities/utilities";
import { InputType } from "../../types/types";

export const billingDatafields: (t: any, countries: any[]) => InputType[] = (
  t: any,
  countries: any[]
) => [
  {
    key: subscriptonName.key,
    name: subscriptonName.name,
    label: t("businessName"),
    rules: { required: true, message: t("requiredField") },
  },
  {
    key: companyAddress.key,
    name: companyAddress.name,
    label: t("address"),
    path: address.name,
    rules: { required: true, message: t("requiredField") },
  },
  {
    key: companyCity.key,
    name: companyCity.name,
    label: t("city"),
    path: city.name,
    rules: { required: true, message: t("requiredField") },
  },
  {
    key: companyProvince.key,
    name: companyProvince.name,
    label: t("province"),
    path: province.name,
  },
  {
    key: companyZip.key,
    name: companyZip.name,
    label: t("zip"),
    path: zip.name,
  },
  {
    key: companyCountry.key,
    name: companyCountry.name,
    label: t("country"),
    path: country.name,
    options: countries,
    rules: { required: true, message: t("requiredField") },
    type: selectType,
  },
  {
    key: companyVat.key,
    name: companyVat.name,
    label: t("vat"),
    path: vat.name,
    rules: { required: true, message: t("requiredField") },
  },
  {
    key: companySdi.key,
    name: companySdi.name,
    path: sdi.name,
    label: t("sdi"),
  },
  {
    key: pec.key,
    name: pec.name,
    label: t("pec"),
    path: pec.name,
  },
];

export const fleetDatafields: (t: any, countries: any[]) => InputType[] = (
  t: any,
  countries: any[]
) => [
  {
    key: customerName.key,
    name: customerName.name,
    label: t("name"),
    rules: { required: true, message: t("requiredField") },
  },
  {
    key: address.key,
    name: address.name,
    label: t("address"),
    path: address.name,
    rules: { required: true, message: t("requiredField") },
  },
  {
    key: city.key,
    name: city.name,
    label: t("city"),
    path: city.name,
    rules: { required: true, message: t("requiredField") },
  },
  {
    key: province.key,
    name: province.name,
    label: t("province"),
    path: province.name,
  },
  {
    key: zip.key,
    name: zip.name,
    label: t("zip"),
    path: zip.name,
  },
  {
    key: country.key,
    name: country.name,
    label: t("country"),
    path: country.name,
    options: countries,
    rules: { required: true, message: t("requiredField") },
    type: selectType,
  },
];

export const ownerDataFields: (t: any) => InputType[] = (t: any) => [
  {
    key: name.key,
    name: name.name,
    label: t("name"),
    rules: { required: true, message: t("requiredField") },
  },
  {
    key: surname.key,
    name: surname.name,
    label: t("surname"),
    rules: { required: true, message: t("requiredField") },
  },
  {
    key: birthdate.key,
    name: birthdate.name,
    label: t("birthdate"),
    path: birthdate.name,
    type: "date",
  },
  {
    key: customerCity.key,
    name: customerCity.name,
    label: t("city"),
    path: city.name,
    rules: { required: true, message: t("requiredField") },
  },
];

export const accountDataFields: (t: any) => InputType[] = (t: any) => [
  {
    key: email.key,
    name: email.name,
    label: t("email"),
    rules: { required: true, message: t("requiredField") },
  },
  {
    key: reportEmail.key,
    name: reportEmail.name,
    label: t("reportEmail"),
    path: reportEmail.name,
  },
  {
    key: companyPhone.key,
    name: companyPhone.name,
    label: t("phone"),
    path: phone.name,
    rules: { required: true, message: t("requiredField") },
    type: numberType,
  },
];
